import React from "react"
import styled from "styled-components"
import Logo from "./Logo"
import useScroll from "./useScrollPosition"

const Menu = styled.nav<{ y: number }>`
  display: flex;
  box-sizing: border-box;
  position: fixed;
  width: 100%;
  height: 64px;
  z-index: 1;
  background-color: ${(props) => (props.y < 1 ? "transparent" : "#FFF")};
  transition: all 300ms ease;
  box-shadow: ${(props) => (props.y < 1 ? "0" : "1px 1px 1px")} rgba(17, 17, 17, 0.3);
  align-items: center;
`

const MenuContainer = styled.div`
  box-sizing: border-box;
  max-width: 1150px;
  margin: auto;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 768px) {
    padding-right: 1rem;
    padding-left: 1rem;
  }
`
const MenuLinks = styled.div<{ textColor?: string }>`
  margin-left: 1rem;
  display: flex;
  align-items: center;
  & a {
    margin-right: 1rem;
    text-decoration: none;
    color: ${(props: any) => (props.textColor ? props.textColor : props.theme.colors.grey)};
    font-weight: bold;
    @media (max-width: 768px) {
      margin-right: 0.5rem;
      font-size: 0.9rem;
    }
  }
  & a:last-child {
    margin-right: 0;
  }
`

export interface NavbarProps {
  children?: React.ReactNode
  textColor?: string
  [rest: string]: any
}
const Navbar = ({ children, textColor, logo, ...rest }: NavbarProps) => {
  const { y } = useScroll({ throttleMs: 300 })
  return (
    <Menu {...rest} y={y}>
      <MenuContainer>
        <Logo textColor={textColor} text={logo} />
        <MenuLinks textColor={textColor}>{children}</MenuLinks>
      </MenuContainer>
    </Menu>
  )
}

export default Navbar
